import { useEffect } from "react";
export const useUpdateBankInfo = (
  bankList,
  beneficiaryValue,
  setValue,
  setBankNameInitial,
  propertyBeneficieries,
  setBenificiaryInitail
) => {
  useEffect(() => {
    if (!beneficiaryValue || !Array.isArray(bankList)) return;
    let beneficiaryData = propertyBeneficieries?.find((item) => item?.value === beneficiaryValue?.value);
    // Find the bank info associated with the selected beneficiary

    setBenificiaryInitail(beneficiaryValue);
    const selectedBank = bankList.find(
      (bank) =>
        bank?.value?.toLowerCase() == beneficiaryData?.beneficiaryBank?.toLowerCase() ||
        bank?.label?.toLowerCase() == beneficiaryData?.beneficiaryBank?.toLowerCase()
    );

    setBankNameInitial(selectedBank);
    if (beneficiaryData) {
      // Update the form fields with selected bank info
      setValue("bankName", selectedBank || "");
      setValue("accountNo", beneficiaryData?.beneficiaryAccountNumber || "");
      setValue("iban", beneficiaryData?.beneficiaryIBAN || "");
    }
  }, [beneficiaryValue, bankList, setValue]);
};
